export default __webpack_public_path__ + "static/media/16.293d34b2.jpg";